<template>
  <div>
    <b-row class="mb-3">
      <b-col lg="3">
        <b-form-checkbox v-model="estaAbierto"> Expandir / Contraer todo </b-form-checkbox>
      </b-col>
      <b-col v-if="esAdmin" lg="3">
        <b-form-checkbox v-model="modoEdicion"> Modo Edición </b-form-checkbox>
      </b-col>
    </b-row>
    <ul>
      <tree-item
        class="item"
        :item="treeData"
        :esta-abierto="estaAbierto"
        :modo-edicion="modoEdicion"
        @anadirCarpeta="anadirCarpeta"
        @anadirDocumento="anadirDocumento"
        @editarDocumento="editarDocumento"
        @borrarDocumento="borrarDocumento"
      />
    </ul>
  </div>
</template>
<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { formatDateEs } from "@/services/date";
import * as repositoriosComercialesApi from "@/services/repositoriosComerciales.js";

export default {
  props: {
    repositoriosComerciales: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      treeData: [],
      estaAbierto: true,
      modoEdicion: false,
    };
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
  },
  mounted() {
    this.rellenarArbol();
  },
  methods: {
    async anadirDocumento(documento) {
      documento.tipo = 1;
      await repositoriosComercialesApi.insertar(documento);
      this.treeData = await repositoriosComercialesApi.listar();
    },
    async anadirCarpeta(documento) {
      documento.tipo = 0;
      await repositoriosComercialesApi.insertar(documento);
      this.treeData = await repositoriosComercialesApi.listar();
    },
    async rellenarArbol() {
      this.treeData = await repositoriosComercialesApi.listar();
    },
    async borrarDocumento(documento) {
      await repositoriosComercialesApi.eliminar(documento.id);
      this.treeData = await repositoriosComercialesApi.listar();
    },
    async editarDocumento(documento) {
      await repositoriosComercialesApi.actualizar(documento);
      this.treeData = await repositoriosComercialesApi.listar();
    },
  },
};
</script>
